import Vue from 'vue'
import commonJs from '@/utils/common'

Object.defineProperty(Vue.prototype, '$commonJs', { value: commonJs })